export class ApiError extends Error {
  code: number

  constructor(message, code = 500) {
    super(message)
    this.name = this.constructor.name
    this.message = message
    
    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, this.constructor)
    } else {
      this.stack = new Error(message).stack
    }

    this.code = code
  }
}

export class ClientError extends Error {
  silent: boolean
  
  constructor(message, silent = false) {
    super(message)
    this.name = this.constructor.name
    this.message = message

    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, this.constructor)
    } else {
      this.stack = new Error(message).stack
    }
    
    this.silent = silent
  }
}
